import { render, staticRenderFns } from "./Conveyor.vue?vue&type=template&id=b9c56be6&"
import script from "./Conveyor.vue?vue&type=script&lang=js&"
export * from "./Conveyor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports